<template>
  <div class="data-row-layout">
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'DataRowLayout'
  }
</script>

<style lang="scss">
  .data-row-layout {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -15px;
  }
</style>
